<beneficiary-documents-library [primaryData]="primaryData" (onDialogClose)="handleDialogClose()"
style="width:100%"></beneficiary-documents-library>
